import { Component, OnInit, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';
import { Plan } from '../../models/plan.model';
import { ProductCar } from '../../models/productCar.model';
import { Product } from '../../models/product.model';
import { UserInformation } from '../../models/userInformation.model';
import { DetailModal } from '../../models/detailModal.model';
import { ProductsService } from '../../services/products/products.service';
import {TagService} from '../../services/seoservice/tag.service';
import { DataLayerService } from '../../services/dataLayer/data-layer.service';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { CardColor } from '../../utils/card-color/card-color';
import { Encrypt } from '../../utils/encrypt/encrypt';
import { AppState } from '../../app.reducer';
import { removePlanFromCar } from '../../redux/actions/carPlanCheckout.actions';
import { addToCarPlan} from '../../redux/actions/carPlanCheckout.actions';
import { environment } from '@env/environment';
import { delay } from 'rxjs/operators';
import { ConfirmTelephoneComponent } from '../../products/components/confirm-telephone/confirm-telephone.component';


@Component({
  selector: 'app-products-base',
  templateUrl: './products-base.component.html',
  styleUrls: ['./products-base.component.scss']
})
export class ProductsBaseComponent implements OnInit {

  plans: Plan[] = [];
  planChosen: Plan[] = [];
  aditionalProducts: ProductCar[] = [];
  products: Product[] = [];
  colorCard: string = '';
  isSelectedPlan: Plan;
  userInformation: UserInformation;
  planType: number = 0;
  count: number = 0;
  countPlan: number = 0;
  summary: number = 0;
  summaryPlan: number = 0;
  public ccEnvironment: any;
  ListSummary: string[] = [];
  textTitle: string = 'Publica un anuncio clasificados - Servicios de avisos publicitarios | Ciencuadras';
  textDescription:string = 'Añade herramientas como tour virtual, fotos 360, ascendidos, destacados con los que lograras que tu anuncio clasificado de inmuebles se venda o arriende en el menor tiempo posible';
  image_url: string = './assets/images/products/';
  imagen_static: string = '';
  mesPlan: string;
  titleChild: string = '';
  user_id: string = '';
  isFullPlan: boolean = false;
  existPlan: boolean = false;
  isMobile: boolean = false;
  havePlan: boolean = false;
  userPrivateZone: boolean = false;
  isUpdateUserInformationRequiered = false;
  isSaveTransactionFail = false;

  constructor(
    private productsService: ProductsService,
    private cookieCiencuadras: CookieCiencuadras,
    private cardColor: CardColor,
    private store: Store<AppState>,
    private tagService:TagService,
    private dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<ConfirmTelephoneComponent>,
    private dataLayerService: DataLayerService,

  ) {
    this.tagService.insertSEO(this.textTitle,this.textDescription,'productos/arma-tu-plan');
    this.ccEnvironment = environment;

  }

  async ngOnInit(): Promise<void> {
    this.planType = parseInt(this.cookieCiencuadras.getCookie('planType'));
    console.log('$$$ planType' , this.planType);
    //Si plantype = 1 es que viene de arma tu plan
    if (this.planType === 1) {
      this.plans.forEach(plan => this.store.dispatch(removePlanFromCar({ id: plan.id })));
      // this.plans = [];
      this.productsService.getPlans(this.cookieCiencuadras.getCookie('clientType')).subscribe(res => {
        let data = res.result;
        console.log("dataplan ", data);
        if (res.status === "ok") {
          this.setDataPlans(data);
        }
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
      });
      //this.isSelectedPlan = false;
    }

    if (localStorage.getItem('__app_storage__') !== null ) {
      const objPlans = JSON.parse(localStorage.getItem('__app_storage__')!).carPlanCheckout;
      if (objPlans.length > 0) {
        // this.plans = [];
        //this.isSelectedPlan = true;
        if(this.planType == 2) {
          this.existPlan = true;
          const objParent = JSON.parse(sessionStorage.getItem("parent"));
          if(objParent != null || objParent != undefined) {
            let planSelected = objParent;
            let nowPlan = sessionStorage.getItem("nowPlan") != "" ? JSON.parse(sessionStorage.getItem("nowPlan")) : sessionStorage.getItem("nowPlan");
            if(nowPlan) {
              this.mesPlan = nowPlan.priceDiscount.toLocaleString();
            }
            this.titleChild = planSelected.name;
            this.ListSummary = nowPlan.summary;
            this.imagen_static = planSelected.image_url;
            sessionStorage.setItem('selectedPlan', JSON.stringify(planSelected));
            this.plans.push(planSelected);
          }
          let children = JSON.parse(sessionStorage.getItem("childrenPlan"));
          if(children?.length >= 0) {
            children.forEach(item => {
              this.plans.push(item);
            });
          }
      }
    }
  }

    //Obtener lista de productos
    this.productsService.getProducts().subscribe(res => {
      let data = res.result;
      if (res.status === "ok") {
        this.setDataProducts(data);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      } else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });
    this.infoPlanUser();

    if(this.planChosen.length != 0){
      await this.consultingInformation();
      await this.waitTime(2500);
      await this.addBulkProducts();
    }
  }

  waitTime(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  infoPlanUser(){
    if (document.location.pathname === '/productos/zona-de-usuario') {
      this.userPrivateZone = true;
    }

    let cripto = new Encrypt();

    this.user_id = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');

    this.store.select('carPlanCheckout').subscribe(plan => {
      this.countPlan = 0;
      this.count = this.count + this.countPlan;
      plan.forEach(item => {
        this.planChosen.push(item);
        this.countPlan = plan.length;
        this.count = this.count + this.countPlan;
        this.summaryPlan = item.priceDiscount;
        this.summary = this.summary + this.summaryPlan;
      });
    });

    this.store.select('carCheckout').subscribe(product => {
      this.aditionalProducts = product;
      this.summary = 0 + this.summaryPlan;
      this.count = 0 + this.countPlan;
      product.forEach(item => {
        this.summary = this.summary + item.totalPrice;
        this.count = this.count + item.quantity;
      });
    });

    let dataUser = this.cookieCiencuadras.getCookie('userInfo');
    this.userInformation = cripto.decryptData(dataUser);
  }

  async addBulkProducts() {
    if(this.planChosen.length > 1){
      this.planChosen.shift();
    }
    const userID = (this.userInformation.identification) ? this.userInformation.identification : this.userInformation.id.toString()
    let allProducts: any = [];
    if (this.planChosen.length > 0) {
      let planSelectedData = this.addDataProducts(this.planChosen[0], 1, false);
      planSelectedData.marketo_custom_object.nombreProducto = "";
      planSelectedData.marketo_custom_object.valorProducto = "";
      planSelectedData.marketo_custom_object.cuposProducto = "";
      planSelectedData.marketo_custom_object.fechaInicioProducto = "";
      planSelectedData.marketo_custom_object.fechaFinProducto = "";
      allProducts.push(planSelectedData);
    }
    if (this.aditionalProducts.length > 0) {
      for (let i = 0; i < this.aditionalProducts.length; i++) {
        let productData = this.addDataProducts(this.aditionalProducts[i], 2, true);
        allProducts.push(productData);
      }
    }
    let jsonData = {
      "external_user_id": userID,
      "external_user_name": this.userInformation.name,
      "external_user_email": this.userInformation.email,
      "external_user_phone": (this.userInformation.phone && this.userInformation.phone !== null) ? this.userInformation.phone.toString() : '7492313412',
      "products": allProducts
    }

    await this.productsService.addBulkProducts(jsonData).then(res => {
      let data = res.result;
      if (res.status === "ok") {
        for (let i = 0; i < res.result.products.length; i++) {
          localStorage.setItem('startDate', res.result.products[i].fechaInicio);
          localStorage.setItem('endDateProducts', res.result.products[i].fechaFin);
          localStorage.setItem('updateDate', res.result.products[i].fechaActualizacionRegistro);
        }
        localStorage.setItem('quotasPublications', res.result.products[0].cupo);
        localStorage.setItem('endDate', res.result.products[0].fechaFin);
        localStorage.setItem("tokenProduct", data.token.toString());
        localStorage.setItem("statusProduct", data.status);
        this.cookieCiencuadras.setCookie('tokenProduct', data.token.toString());
      }
    }).catch((err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      }
      else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });
    return Promise.resolve(true);
  }

  addDataProducts(product: any, tipoItem: number, aditional: boolean) {
    const dataLayer = [
      {
        "name": "brand",
        "value": "ciencuadras"
      },
      {
        "name": "category",
        "value": "productos"
      },
      {
        "name": "dimension24",
        "value": "productos"
      },
      {
        "name": "dimension35",
        "value": ""
      },
      {
        "name": "dimension36",
        "value": ""
      },
      {
        "name": "dimension37",
        "value": this.timeSeries(product.detailModal.validity)
      },
      {
        "name": "dimension38",
        "value": aditional==true ? product.summary : product.summary.join(" - ")
      },
      {
        "name": "dimension39",
        "value": ""
      },
      {
        "name": "id",
        "value": product.id
      },
      {
        "name": "name",
        "value": product.name
      },
      {
        "name": "price",
        "value": product.price
      },
      {
        "name": "quantity",
        "value": 1
      },
      {
        "name": "variant",
        "value": this.timeSeries(product.detailModal.validity)
      }
    ];
    let basePrice = product.basePrice;
    if (product.discount !== 0) {
      let basePriceDiscount = product.basePrice - (product.basePrice * product.discount / 100);
      basePrice = basePriceDiscount;
    }
    let quantity = product.quantity
    if (tipoItem == 1) {
      quantity = 1
    }
    let productData = {
      "price": basePrice,
      "product_id": product.carritoId,
      "quantity": quantity,
      "productos_analytics": dataLayer,
      "external_product_id": product.external_product_id,
      "observations": {
        "proyectoId": "1",
        "item": product.id,
        "tipoItem": tipoItem,
      },
      "marketo_lead": {
        "cCTD": this.userInformation.typeDocument,
        "cCID": this.userInformation.identification,
        "Email": this.userInformation.email,
        "MobilePhone": this.userInformation.phone,
        "FirstName": this.userInformation.name,
        "LastName": this.userInformation.lastname,
        "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
        "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
        "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
        "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
        "cCOrigendelosDatos": environment.name,
        "cCPrueba": environment.production === false ? 1 : 0,
        "cCConsentimientoComercial": true,
        "cCConsentimiento": true,
        "cCRegistroSolicitudAvaluo": false
      },
      "marketo_custom_object": {
        "iDUsuario": this.userInformation.id,
        "Email": this.userInformation.email,
        "token": this.cookieCiencuadras.getCookie("tokenProduct"),
        "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
        "tipoDePlan": this.planChosen.length > 0 ? this.planChosen[0].name : "",
        "cuposPublicaciones": localStorage.getItem("quotasPublications"),
        "estadoPlan": localStorage.getItem("statusProduct"),
        "duracionPlan": this.planChosen.length > 0 ? this.planChosen[0].descriptionValuePlan : "",
        "fechaInicioPlan": localStorage.getItem("startDate"),
        "fechaFinPlan": localStorage.getItem("endDate"),
        "valorPlan": this.planChosen.length > 0 ? this.planChosen[0].price : 0,
        "nombreProducto": this.aditionalProducts.length > 0 ? product.name : product.name ? "" : "",
        "valorProducto": this.aditionalProducts.length > 0 ? product.price : product.price ? 0: 0,
        "cuposProducto": quantity,
        "fechaInicioProducto": localStorage.getItem("startDate"),
        "fechaFinProducto": localStorage.getItem("endDateProducts"),
        "estadoProducto": localStorage.getItem("statusProduct"),
        "fechaActualizacionRegistro": localStorage.getItem("updateDate")
      }
    }
    return productData;
  }

  async saveTransactionService() {
    const planes: Plan[] = this.planChosen;
    const productos: ProductCar[] = this.aditionalProducts;
    let padreId: number = null!;
    let token = localStorage.getItem('tokenProduct');

    let transaccionCarritoDet: any = [];

    const userID = (this.userInformation.identification) ? this.userInformation.identification : this.userInformation.id.toString();
    if (planes.length > 0) {
      let plan = planes[0];
      padreId = plan.id;
      let basePrice = plan.basePrice;
      if (plan.discount !== 0) {
        let basePriceDiscount = plan.basePrice - (plan.basePrice * plan.discount / 100);
        basePrice = basePriceDiscount;
      }
      transaccionCarritoDet.push(
        {
          "cantidad": 1,
          "itemId": plan.id,
          "tipo": 1,
          "valorTotal": basePrice,
          "observations": {
            "proyectoId": "1",
            "item": plan.id,
            "tipoItem": 1,
          },
          "marketo_lead": {
            "cCTD": this.userInformation.typeDocument,
            "cCID": this.userInformation.identification,
            "Email": this.userInformation.email,
            "MobilePhone": this.userInformation.phone,
            "FirstName": this.userInformation.name,
            "LastName": this.userInformation.lastname,
            "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
            "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
            "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
            "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
            "cCOrigendelosDatos": environment.name,
            "cCPrueba": environment.production === false ? 1 : 0,
            "cCConsentimientoComercial": true,
            "cCConsentimiento": true,
            "cCRegistroSolicitudAvaluo": false
          },
          "marketo_custom_object": {
            "iDUsuario": this.userInformation.id,
            "Email": this.userInformation.email,
            "token": this.cookieCiencuadras.getCookie("tokenProduct"),
            "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
            "tipoDePlan": plan.name,
            "cuposPublicaciones": localStorage.getItem("quotasPublications"),
            "estadoPlan": localStorage.getItem("statusProduct"),
            "duracionPlan": this.planChosen.length > 0 ? this.planChosen[0].descriptionValuePlan : "",
            "fechaInicioPlan": localStorage.getItem("startDate"),
            "fechaFinPlan": localStorage.getItem("endDate"),
            "valorPlan": plan.price,
            "nombreProducto": "",
            "valorProducto": 0,
            "cuposProducto": 0,
            "fechaInicioProducto": "",
            "fechaFinProducto": "",
            "estadoProducto": "",
            "fechaActualizacionRegistro": localStorage.getItem("updateDate")
          }
        }
      );
      let includedProducts = plan.includedProducts;
      includedProducts.forEach(producto => {
        transaccionCarritoDet.push(
          {
            "padreId": padreId,
            "cantidad": producto.cantidadXPlan,
            "itemId": producto.id,
            "tipo": 2,
            "valorTotal": 0,
            "observations": {
              "proyectoId": "1",
              "item": producto.id,
              "tipoItem": 2
            },
            "marketo_lead": {
              "cCTD": this.userInformation.typeDocument,
              "cCID": this.userInformation.identification,
              "Email": this.userInformation.email,
              "MobilePhone": this.userInformation.phone,
              "FirstName": this.userInformation.name,
              "LastName": this.userInformation.lastname,
              "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
              "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
              "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
              "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
              "cCOrigendelosDatos": environment.name,
              "cCPrueba": environment.production === false ? 1 : 0,
              "cCConsentimientoComercial": true,
              "cCConsentimiento": true,
              "cCRegistroSolicitudAvaluo": false
            },
            "marketo_custom_object": {
              "iDUsuario": this.userInformation.id,
              "Email": this.userInformation.email,
              "token": this.cookieCiencuadras.getCookie("tokenProduct"),
              "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
              "tipoDePlan": "",
              "cuposPublicaciones": 0,
              "estadoPlan": "",
              "duracionPlan": "",
              "fechaInicioPlan": "",
              "fechaFinPlan": "",
              "valorPlan": 0,
              "nombreProducto": producto.nombre,
              "valorProducto": producto.precio,
              "cuposProducto": producto.cantidadXPlan,
              "fechaInicioProducto": localStorage.getItem("startDate"),
              "fechaFinProducto": localStorage.getItem("endDateProducts"),
              "estadoProducto": localStorage.getItem("statusProduct"),
              "fechaActualizacionRegistro": localStorage.getItem("updateDate")
            }
          }
        );
      });
    }
    if (productos.length > 0) {
      productos.forEach(producto => {
        let basePrice = producto.basePrice;
        if (producto.discount !== 0) {
          let basePriceDiscount = producto.basePrice - (producto.basePrice * producto.discount / 100);
          basePrice = basePriceDiscount;
        }
        transaccionCarritoDet.push(
          {
            "cantidad": producto.quantity,
            "itemId": producto.id,
            "tipo": 2,
            "valorTotal": basePrice,
            "observations": {
              "proyectoId": "1",
              "item": producto.id,
              "tipoItem": 2
            },
            "marketo_lead": {
              "cCTD": this.userInformation.typeDocument,
              "cCID": this.userInformation.identification,
              "Email": this.userInformation.email,
              "MobilePhone": this.userInformation.phone,
              "FirstName": this.userInformation.name,
              "LastName": this.userInformation.lastname,
              "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
              "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
              "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
              "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
              "cCOrigendelosDatos": environment.name,
              "cCPrueba": environment.production === false ? 1 : 0,
              "cCConsentimientoComercial": true,
              "cCConsentimiento": true,
              "cCRegistroSolicitudAvaluo": false
            },
            "marketo_custom_object": {
              "iDUsuario": this.userInformation.id,
              "Email": this.userInformation.email,
              "token": this.cookieCiencuadras.getCookie("tokenProduct"),
              "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
              "tipoDePlan": "",
              "cuposPublicaciones": 0,
              "estadoPlan": "",
              "duracionPlan": "",
              "fechaInicioPlan": "",
              "fechaFinPlan": "",
              "valorPlan": 0,
              "nombreProducto": producto.name,
              "valorProducto": basePrice,
              "cuposProducto": producto.quantity,
              "fechaInicioProducto": localStorage.getItem("startDate"),
              "fechaFinProducto": localStorage.getItem("endDateProducts"),
              "estadoProducto": localStorage.getItem("statusProduct"),
              "fechaActualizacionRegistro": localStorage.getItem("updateDate")
            }
          }
        );
      });
    }
    this.productsService.savePurchaseIntent(
      this.userInformation.name, // last name
      this.userInformation.email, // user email
      this.userInformation.name, //name
      userID, // user cc o id
      1,
      token,
      transaccionCarritoDet,
      this.userInformation.id, // user id
      this.summary
    ).pipe().subscribe(async res => {
      console.log('------------------ savePurchaseIntent:', res);
      // 
      if (res.status === 'ok') {
        this.dialog.closeAll();
      } else {
        this.isSaveTransactionFail = true;
      }
    }, async (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      } else {
        this.isSaveTransactionFail = true;
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });

  }

  setDataPlans(data: any) {
    console.log('$$$ data que llega a metodo setDataPlans' , data);
    let pos = 0;
    for (let i = 0; i < data.length; i++) {
      let discountPrice = 0;
      let products: string[] = [];
      let colorCard = '';
      let clientType = this.cookieCiencuadras.getCookie('clientType')
      if (data[i].tipoPlanNumero === this.planType) {
        console.log('set existPlan true');
        this.existPlan = true;
        /*if (data[i].porcentajeDescuentoNumero > 0 && data[i].porcentajeDescuentoNumero !== null) {
          discountPrice = data[i].precio - (data[i].precio * data[i].porcentajeDescuentoNumero / 100);
        } else {
          discountPrice = data[i].precio;
        }*/
        discountPrice = data[i].precio;
        products = data[i].caracteristicasPlan.split(";");
        if (clientType === '2') {
          colorCard = 'bg-gradient-green-1';
        } else if (clientType === '1') {
          colorCard = 'bg-gradient-blue-3';
        }
        this.imagen_static = data[0].imagenEstatica;
        let relevantChar: string[] = [];
        if (data[i].caracteristicasRelevantes !== undefined && data[i].caracteristicasRelevantes !== null) {
          relevantChar = data[i].caracteristicasRelevantes.split(";");
        }
        let urlName = '';
        let url = '';
        let detail: DetailModal = {
          name: data[i].nombre,
          price: data[i].precio,
          validity: data[i].mesesVigenciaNumero,
          validityLabel: data[i].etiquetaVigenciaServicio,
          priceLabel: data[i].etiquetaPrecioDetalle,
          topDescription: data[i].descripcionSuperiorDetalle,
          relevantCharacteristics: relevantChar,
          terms: data[i].terminosDetalle,
          aditionalInfoHTML: data[i].informacionAdicionalHtml,
          urlName: urlName,
          url: url,
          duration: data[i].tiempoDuracionNumero,
          unitTimeDuration: data[i].unidadTiempoNumero,
          duratrionLabel: data[i].descripcionDuracionProducto,
          image_url: data[i].imagenEstatica + '-detalle',
          discount: data[i].porcentajeDescuentoNumero,
          priceDiscount: discountPrice,
          type: 'plan'
        }
        let plan: Plan = {
          external_product_id: Date.now().toString(),
          carritoId: data[i].carritoId,
          token: "",
          id: data[i].id,
          name: data[i].nombre,
          summary: products,
          price: data[i].precio,
          basePrice: data[i].precioBase,
          descriptionValuePlan: data[i].descripcionValorPlan,
          stock: data[i].stock,
          available_stock: data[i].disponibleStock,
          image_url: data[i].imagenEstatica,
          image_alt: data[i].altImagen,
          iva: data[i].iva,
          priceIva: data[i].ivaPrecio,
          idClientType: clientType,
          discount: data[i].porcentajeDescuentoNumero,
          priceDiscount: discountPrice,
          validity: data[i].mesesVigenciaNumero,
          colorCard: colorCard,
          termsDescription: data[i].descripcionTerminos,
          detailModal: detail,
          includedProducts: data[i].productoDTOList,
          position: pos,
        };
        this.plans.push(plan);    // se va llenando el arreglo plans que es el que se despliega en el front
        if(pos == 0) {
          this.ListSummary = products;
          this.mesPlan = discountPrice.toLocaleString();
          this.isSelectedPlan = plan;
        }
        pos++;
      }
    }
  }

  setDataProducts(data: any) {
    for (let i = 0; i < data.length; i++) {
      let discountPrice = 0;
      let clientType = this.cookieCiencuadras.getCookie('clientType');
 
      if (data[i].porcentajeDescuentoNumero > 0 && data[i].porcentajeDescuentoNumero !== null) {
        discountPrice = data[i].precio - (data[i].precio * data[i].porcentajeDescuentoNumero / 100);
      } else {
        discountPrice = data[i].precio;
      }

      let relevantChar: string[] = [];
      if (data[i].caracteristicasRelevantes !== undefined && data[i].caracteristicasRelevantes !== null) {
        relevantChar = data[i].caracteristicasRelevantes.split(";");
      }
      let urlName = '';
      let url = '';
      if (data[i].nombreUrlEnlace !== undefined && data[i].nombreUrlEnlace !== null) {
        let urlData = data[i].nombreUrlEnlace.split(":");
        urlName = urlData[0];
        url = urlData[1];
      }

      let duration = '';
      let unitTimeDuration = '';

      switch (data[i].unidadTiempoNumero) {
        case 1:
          unitTimeDuration = 'Indefinido';
          duration = '';
          break;
        case 2:
          unitTimeDuration = 'Un día';
          duration = '';
          break;
        case 3:
          unitTimeDuration = 'dias';
          duration = data[i].unidadTiempoNumero;
          break;
        case 4:
          unitTimeDuration = 'Mes';
          duration = data[i].unidadTiempoNumero;
          break;
        case 5:
          unitTimeDuration = 'Año';
          duration = data[i].unidadTiempoNumero;
          break;
        case 6:
          unitTimeDuration = 'Meses';
          duration = data[i].unidadTiempoNumero;
          break;
        default:
          break;
      }

      let detail: DetailModal = {
        name: data[i].nombre,
        price: data[i].precio,
        validity: data[i].mesesVigenciaNumero,
        validityLabel: data[i].etiquetaVigenciaServicio,
        priceLabel: data[i].etiquetaPrecioDetalle,
        topDescription: data[i].descripcionSuperiorDetalle,
        relevantCharacteristics: relevantChar,
        terms: data[i].terminosDetalle,
        aditionalInfoHTML: '',
        urlName: urlName,
        url: url,
        duration: duration,
        unitTimeDuration: unitTimeDuration,
        duratrionLabel: data[i].descripcionDuracionProducto,
        image_url: data[i].imagenEstatica + '-detalle',
        discount: data[i].porcentajeDescuentoNumero,
        priceDiscount: discountPrice,
        type: 'product'
      }

      let product: Product = {
        carritoId: data[i].carritoId,
        token: "",
        id: data[i].id,
        name: data[i].nombre,
        summary: data[i].resumen,
        price: data[i].precio,
        basePrice: data[i].precioBase,
        quantityPlan: data[i].cantidadXPlan,
        prodCategory: data[i].categoriaProdNumero,
        code: data[i].codigo,
        createdManual: data[i].creadoManual,
        stock: data[i].stock,
        available_stock: data[i].disponibleStock,
        image_url: data[i].imagenEstatica,
        image_alt: data[i].altImagen,
        iva: data[i].iva,
        priceIva: data[i].ivaPrecio,
        originId: data[i].origenId,
        idClientType: clientType,
        discount: data[i].porcentajeDescuentoNumero,
        priceDiscount: discountPrice,
        detailModal: detail,
      };
      this.products.push(product);  // se va llenando el arreglo products que es el que se despliega en el front
    }
  }

  onSelectedPlan(selected: Plan) {
    this.isSelectedPlan = selected
    this.mesPlan = this.isSelectedPlan.priceDiscount.toLocaleString();
    this.ListSummary = this.isSelectedPlan.summary;
  }

  async consultingInformation() {

    let dataLayerProduct: { name: string; id: number; price: number; category: string; quantity: number; }[] = [];

    if (this.planChosen.length > 0) {
      this.planChosen.forEach(plan => {
        const newPlan = {
          name: plan.name,
          id: plan.id,
          price: plan.priceDiscount,
          category: "Publicacion",
          quantity: 1,
        }
        dataLayerProduct.push(newPlan)
      });
    }

    if (this.aditionalProducts.length > 0) {
      this.aditionalProducts.forEach(product => {
        const newProduct = {
          name: product.name,
          id: product.id,
          price: product.priceDiscount,
          category: "Publicacion",
          quantity: product.quantity,
        }
        dataLayerProduct.push(newProduct)
      });
    }

    this.dataLayerService.onPushDataLayer({
      event: "checkout",
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: "Medio de pago seleccionado" },
          products: dataLayerProduct,
        },
      },
    });

    if (this.user_id) {
      let userInformation: boolean = await this.getUserInformation(this.user_id);
      this.beforeBuy(userInformation);
    }
  }

  async beforeBuy(userInformation: boolean) {

    if (userInformation) {
      let typeUser = this.userInformation.typeUser;
      let openDialog: boolean;

      if (typeUser === 9) {
        if (!this.userInformation.phone || !this.userInformation.cellPhone) {
          openDialog = await this.phoneValidation();
        } else {
          openDialog = true;
        }
      } else {
        openDialog = true;
      }

      if (openDialog) {
        await this.getUserInformation(this.user_id);
        if (this.havePlan === false || this.userPrivateZone) {
          await this.buy();
        }
      } else {
        if (typeUser === 9) {
          this.isUpdateUserInformationRequiered = true;
        }
      }
    }
  }

  async buy(fromView = false) {
    if(fromView) {
      this.dataLayerService.pushTagEventClick({'event':'ga_event','category':'productos','action':'CCW - planes activos','label':'si'});
    }
    this.isSaveTransactionFail = false;
    if (this.planChosen.length >= 1 && this.havePlan === false) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else if (this.havePlan || this.userInformation.typeUser === 9) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else if (this.userPrivateZone) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else {
      this.dialog.closeAll();
    }

  }

  async phoneValidation() {
    this.dialogRef = this.dialog.open(ConfirmTelephoneComponent, {
      width: "500px",
      panelClass: "full-mobile",
    });

    return this.dialogRef?.afterClosed()
      .toPromise() // here you have a Promise instead an Observable
      .then(result => {
        console.log('phoneValidation result: ', result);
        return Promise.resolve(result); // will retun a Promise here
      });
  }

  async getUserInformation(id: string): Promise<boolean> {

    return new Promise((resolve) => {
      this.productsService.getUserInformation(
        id
      ).pipe().subscribe(res => {
        if (res.status) {
          let cripto = new Encrypt();
          this.userInformation = res.data;
          this.cookieCiencuadras.setCookie('userInfo', cripto.encryptData(this.userInformation));
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

  private timeSeries(value) {
    switch (value) {
      case 1:
        return 'mensual'
      case 6:
        return 'semestral'
      case 12:
        return 'anual'   
      default:
        return 'no aplica';
    }
  }

  async selectPlan() {
    this.isFullPlan = true;
    let selectPlan = sessionStorage.getItem("selectedPlan") != "" ? JSON.parse(sessionStorage.getItem("selectedPlan")) : sessionStorage.getItem("selectedPlan");
    let plan:Plan;
    if(selectPlan == "" || selectPlan == null) {
      plan = this.isSelectedPlan;
      sessionStorage.setItem('selectedPlan', JSON.stringify(plan));
      this.store.dispatch(addToCarPlan({plan}));
    }else {
      let nowPlan = sessionStorage.getItem("nowPlan") != "" ? JSON.parse(sessionStorage.getItem("nowPlan")) : sessionStorage.getItem("nowPlan");
      if(nowPlan) {
        plan = this.isSelectedPlan;
        if(nowPlan.carritoId != undefined && nowPlan.carritoId != plan.carritoId) {
          this.store.dispatch(removePlanFromCar({ id: nowPlan.id }))
          this.store.dispatch(addToCarPlan({plan}));
          sessionStorage.removeItem("nowPlan");
          sessionStorage.setItem('nowPlan', JSON.stringify(plan));
        }
      }else {
        plan = this.isSelectedPlan;
        if(selectPlan.carritoId != undefined) {
          this.store.dispatch(removePlanFromCar({ id: selectPlan.id }))
          this.store.dispatch(addToCarPlan({plan}));
          sessionStorage.removeItem("selectedPlan");
          sessionStorage.setItem('selectedPlan', JSON.stringify(plan));
        }
      }
      this.dataLayerService.pushTagByEventCar(plan, 'addToCart', 'add', 1);
      this.infoPlanUser();
      await this.consultingInformation();
      await this.waitTime(2500);
      await this.addBulkProducts();
    }
  }

  OpenOnboardingModal(Onboarding: any){
    console.log("event onboarding -->", Onboarding);

    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog.open(CcLoginComponent, {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

}
